import Box from '@mui/material/Box';
import type { CSSProperties } from 'react';

interface Props {
  size?: number;
  color?: string;
  style?: CSSProperties;
  variant?: string;
}

export default function PeriodSvgIcon({ size = 20, color = 'currentColor', style }: Props) {
  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: size,
        height: size,
        color,
        '& svg': {
          width: '100%',
          height: '100%',
          display: 'block'
        }
      }}
      style={style}
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path
          fill="currentColor"
          d="M19 2h-1V1c0-.552-.448-1-1-1s-1 .448-1 1v1H8V1c0-.552-.448-1-1-1S6 .448 6 1v1H5C2.243 2 0 4.243 0 7v12c0 2.757 2.243 5 5 5h14c2.757 0 5-2.243 5-5V7c0-2.757-2.243-5-5-5ZM5 4h1v1c0 .552.448 1 1 1s1-.448 1-1V4h8v1c0 .552.448 1 1 1s1-.448 1-1V4h1c1.654 0 3 1.346 3 3v1H2V7c0-1.654 1.346-3 3-3Zm14 18H5c-1.654 0-3-1.346-3-3v-9h20v9c0 1.654-1.346 3-3 3Zm-8-8c0-.552.448-1 1-1h5c.552 0 1 .448 1 1s-.448 1-1 1h-5c-.552 0-1-.448-1-1Zm0 4c0-.552.448-1 1-1h3c.552 0 1 .448 1 1s-.448 1-1 1h-3c-.552 0-1-.448-1-1Zm-5-3a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm0 4a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z"
        />
      </svg>
    </Box>
  );
}
